<template>
  <section
      class="hero-wallet-root w-full max-w-full min-w-0 overflow-hidden rounded-3xl border border-gray-700 bg-gray-950 shadow-2xl mb-6"
      dir="rtl"
  >
    <!-- Background -->
    <div class="absolute-layer pointer-events-none">
      <div class="absolute -top-28 -right-20 w-64 h-64 rounded-full bg-purple-500/20 blur-3xl pulse-orb"></div>
      <div
          class="absolute -bottom-32 -left-24 w-72 h-72 rounded-full bg-emerald-500/20 blur-3xl pulse-orb-delayed"></div>
      <div class="absolute inset-0 bg-gradient-to-br from-gray-800/95 via-gray-950 to-black"></div>
      <div class="absolute inset-0 hero-grid opacity-[0.07]"></div>
    </div>

    <div class="relative z-10 p-3 sm:p-5">
      <!-- Powered By Row -->

      <!-- Main Row -->
      <div class="grid grid-cols-1 xl:grid-cols-12 gap-4 min-w-0">
        <!-- Welcome Side -->
        <div class="xl:col-span-4 min-w-0">
          <div class="rounded-2xl border border-white/10 bg-white/[0.035] px-3 py-2 mb-4">
            <div class="flex items-center justify-between gap-3 min-w-0">
              <div class="flex items-center gap-2 min-w-0">
                <v-img
                    src="/img/icons/soroosh.png"
                    max-height="58"
                    max-width="58"
                    contain
                    class="shrink-0"
                ></v-img>

                <div class="min-w-0">
                  <p class="text-[10px] mt-5 sm:text-[11px] text-gray-500 tracking-[0.22em] uppercase truncate">
                    POWERED BY
                  </p>
                </div>

                <div class="w-3 h-3 bg-green-400 rounded-full animate-pulse shrink-0"></div>
              </div>

              <button
                  style="max-width:40px"
                  @click="fetchBalance"
                  :disabled="loading"
                  class="shrink-0 p-2 sm:px-4 bg-gradient-to-r from-purple-600 to-pink-600 rounded-xl text-white text-[11px] sm:text-xs font-semibold hover:opacity-90 transition-opacity flex items-center gap-2 disabled:opacity-60"
              >
                <svg
                    class="w-4 h-4"
                    :class="{ 'spin-slow': loading }"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                >
                  <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"
                  />
                </svg>
                <span class="hidden xs:inline">بروزرسانی</span>
              </button>
            </div>
          </div>

          <div class=" rounded-3xl border border-white/10 bg-white/[0.035] p-4 sm:p-5 overflow-hidden">
            <div class="flex items-start gap-4 min-w-0">
              <div class="min-w-0 flex-1">
                <h1 class="text-xl sm:text-2xl font-black text-white leading-8">
                  <span
                      class="bg-gradient-to-r from-purple-400 via-pink-400 to-orange-400 bg-clip-text text-transparent">
                    {{ userFirstName }}
                  </span>
                  <span class="text-gray-300 mr-2">خوش آمدید</span>
                </h1>

                <div class="flex flex-wrap items-center gap-2 mt-4">
                  <div class="relative">
                    <div
                        class="w-8 h-8 rounded-full bg-gradient-to-r from-green-500/20 to-emerald-600/20 flex items-center justify-center">
                      <svg class="w-5 h-5 text-green-400" fill="currentColor" viewBox="0 0 20 20">
                        <path
                            fill-rule="evenodd"
                            d="M2.166 4.999A11.954 11.954 0 0010 1.944 11.954 11.954 0 0017.834 5c.11.65.166 1.32.166 2.001 0 5.225-3.34 9.67-8 11.317C5.34 16.67 2 12.225 2 7c0-.682.057-1.35.166-2.001zm11.541 3.708a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                            clip-rule="evenodd"
                        />
                      </svg>
                    </div>
                    <div class="absolute -top-1 -right-1 w-3 h-3 bg-green-400 rounded-full animate-ping"></div>
                  </div>

                  <span class="text-gray-400 text-xs">سطح دسترسی:</span>

                  <span
                      v-if="user.user_type == 'prtnr'"
                      class="px-3 py-1 bg-gradient-to-r from-green-500 to-emerald-600 rounded-full text-xs font-semibold text-white shadow-lg">
                    شریک
                  </span>
                  <span
                      v-if="user.user_type == 'ma'"
                      class="px-3 py-1 bg-gradient-to-r from-amber-500 to-yellow-600 rounded-full text-xs font-semibold text-white shadow-lg">
                    مدیر
                  </span>
                  <span
                      v-if="user.user_type != 'prtnr' && user.user_type != 'ma' "
                      class="px-3 py-1 bg-gradient-to-r from-rose-500 to-red-600 rounded-full text-xs font-semibold text-white shadow-lg">
                    غیرمجاز
                  </span>
                </div>

              </div>
            </div>
          </div>
          <div class="mt-3 rounded-3xl bg-black/25 border border-white/10 overflow-hidden">
            <div class="flex items-center justify-between gap-3 min-w-0">
              <div class="min-w-0 p-2">
                <div class="flex items-center justify-between gap-3 min-w-0">
                  <div class="min-w-0">
                    <p class="text-xs text-gray-100 font-medium truncate">
                      آخرین فروش
                    </p>
                    <p class="text-[10px] text-gray-500 mt-1 truncate">
                      {{ lastSaleTitle }}
                    </p>
                  </div>

                  <p class="text-xs font-bold text-emerald-400 shrink-0" dir="ltr">
                    + {{ formatMoney(lastSaleAmount) }}
                  </p>
                </div>
              </div>
              <div class="min-w-0 p-2">
                <div class="flex items-center justify-between gap-3 min-w-0">
                  <div class="min-w-0">
                    <p class="text-xs text-gray-100 font-medium truncate">
                      آخرین پرداخت
                    </p>
                    <p class="text-[10px] text-gray-500 mt-1 truncate">
                      {{ lastPaymentTitle }}
                    </p>
                  </div>

                  <p class="text-xs font-bold text-blue-400 shrink-0" dir="ltr">
                    - {{ formatMoney(lastPaymentAmount) }}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Wallet Side -->
        <div class="xl:col-span-8 min-w-0">
          <div
              class="h-full rounded-3xl border border-white/10 bg-gradient-to-br from-gray-800/80 via-gray-950 to-black p-4 sm:p-5 overflow-hidden">
            <div v-show="false" class="flex flex-col lg:flex-row lg:items-start lg:justify-between gap-4 min-w-0">
              <div class="min-w-0">
                <div class="flex items-center gap-3">
                  <div
                      class="w-11 h-11 rounded-2xl bg-emerald-500/15 border border-emerald-400/20 flex items-center justify-center shrink-0">
                    <i class="fas fa-wallet text-emerald-300 text-base"></i>
                  </div>

                  <div class="min-w-0">
                    <h3 class="text-sm font-black text-white truncate">
                      کیف پول فروش شریک
                    </h3>
                  </div>
                </div>
              </div>

              <div class="grid grid-cols-2 gap-2 min-w-0 lg:w-[320px]">
                <div class="min-w-0">
                  <label class="block text-[10px] text-gray-500 mb-1">
                    منبع
                  </label>

                  <select
                      v-model="selectedSource"
                      @change="onFilterChange"
                      class="w-full min-w-0 bg-black/30 border border-white/10 rounded-2xl px-3 py-2 text-[11px] text-gray-200 focus:outline-none focus:border-emerald-400/60"
                  >
                    <option
                        v-for="src in sourceOptions"
                        :key="src.value"
                        :value="src.value"
                    >
                      {{ src.label }}
                    </option>
                  </select>
                </div>

                <div class="min-w-0">
                  <label class="block text-[10px] text-gray-500 mb-1">
                    شریک
                  </label>

                  <div
                      class="w-full min-w-0 bg-black/30 border border-white/10 rounded-2xl px-3 py-2 text-[11px] text-gray-300 truncate">
                    {{ partnerId ? `#${partnerId}` : 'همه شریک‌ها' }}
                  </div>
                </div>
              </div>
            </div>

            <!-- Loading -->
            <div v-if="loading" class="py-12 text-center">
              <div
                  class="mx-auto w-12 h-12 rounded-2xl bg-emerald-500/10 border border-emerald-400/20 flex items-center justify-center">
                <i class="fas fa-circle-notch fa-spin text-emerald-300 text-xl"></i>
              </div>

              <p class="text-gray-400 text-xs mt-3">
                در حال محاسبه موجودی...
              </p>
            </div>

            <!-- Error -->
            <div v-else-if="error" class="py-10 text-center">
              <div
                  class="mx-auto w-12 h-12 rounded-2xl bg-red-500/10 border border-red-400/20 flex items-center justify-center">
                <i class="fas fa-exclamation-triangle text-red-300 text-xl"></i>
              </div>

              <p class="text-red-300 text-xs mt-3">
                {{ error }}
              </p>

              <button
                  @click="fetchBalance"
                  class="mt-4 px-4 py-2 rounded-2xl bg-red-500/20 border border-red-400/20 text-red-200 text-xs hover:bg-red-500/30 transition"
              >
                تلاش مجدد
              </button>
            </div>

            <template v-else>
              <!-- Wallet Content -->
              <div class="grid grid-cols-1 lg:grid-cols-12 gap-3 mt-5 min-w-0">
                <!-- Main bank card -->
                <div class="lg:col-span-6 min-w-0">
                  <div class="relative h-full rounded-3xl border border-white/10 bg-white/[0.045] p-4 overflow-hidden">
                    <div class="absolute top-0 left-0 w-24 h-24 rounded-full bg-emerald-400/10 blur-2xl"></div>

                    <div class="relative z-10 h-full flex flex-col justify-between">
                      <div>
                        <div class="flex items-start justify-between gap-3">
                          <div class="min-w-0">
                            <p class="text-[10px] text-gray-400">
                              موجودی قابل تسویه
                            </p>

                            <h2 class="mt-2 text-2xl sm:text-3xl font-black text-white tracking-tight break-safe"
                                dir="ltr">
                              {{ formatMoney(balanceAmount) }}
                            </h2>
                          </div>

                          <div style="max-width: 30px"
                               class=" h-9 rounded-xl bg-gradient-to-br from-yellow-200/90 to-yellow-500/80 shadow-lg flex items-center justify-center shrink-0">
                            💰
                          </div>
                        </div>
                      </div>

                      <div class="mt-5 flex items-center justify-between gap-3">
                        <span class="text-[10px] text-gray-500 tracking-[0.2em]">
                          EXUNI WALLET
                        </span>

                        <span class="inline-flex items-center gap-1 text-[10px] text-emerald-300">
                          <span class="w-2 h-2 rounded-full bg-emerald-400 animate-pulse"></span>
                          {{ formatDateShort(calculatedUntil) }}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- Stats -->
                <div class="lg:col-span-6 min-w-0">
                  <div class="grid grid-cols-2 gap-2 h-full">
                    <div class="rounded-2xl bg-emerald-500/10 border border-emerald-400/20 px-3 py-3 min-w-0">
                      <p class="text-[10px] text-emerald-200/80 truncate">
                        فروش خالص
                      </p>

                      <p class="text-xs font-bold text-emerald-300 mt-1 truncate" dir="ltr">
                        {{ formatMoney(netTotal) }}
                      </p>

                      <p class="text-[10px] text-gray-500 mt-0.5 truncate" dir="ltr">
                        ناخالص: {{ formatMoney(grossTotal) }}
                      </p>

                      <p
                          v-if="returnsTotal > 0"
                          class="text-[10px] text-rose-300 mt-0.5 truncate"
                          dir="ltr"
                      >
                        مرجوعی: - {{ formatMoney(returnsTotal) }}
                      </p>
                    </div>
                    <div class="rounded-2xl bg-gray-500/10 border border-gray-400/10 px-3 py-3 min-w-0">
                      <p class="text-[10px] text-gray-400 truncate">
                        پرداخت‌شده
                      </p>
                      <p class="text-xs font-bold text-gray-300 mt-1 truncate" dir="ltr">
                        {{ formatMoney(paidTotal) }}
                      </p>
                      <p class="text-[10px] text-gray-500 mt-0.5">
                        {{ formatNumber(paymentCount) }} پرداخت
                      </p>
                    </div>
                    <div class="rounded-2xl bg-blue-500/10 border border-blue-400/20 px-3 py-3 min-w-0">
                      <div class="flex items-center justify-between gap-2">
                        <p class="text-[10px] text-blue-200 truncate">
                          آنلاین
                        </p>
                        <i class="fas fa-globe text-blue-300 text-xs"></i>
                      </div>
                      <p class="text-xs font-bold text-white mt-1 truncate" dir="ltr">
                        {{ formatMoney(shopTotal) }}
                      </p>
                      <p class="text-[10px] text-gray-500 mt-0.5">
                        {{ formatNumber(shopItemCount) }} آیتم
                      </p>
                    </div>

                    <div class="rounded-2xl bg-purple-500/10 border border-purple-400/20 px-3 py-3 min-w-0">
                      <div class="flex items-center justify-between gap-2">
                        <p class="text-[10px] text-purple-200 truncate">
                          حضوری
                        </p>
                        <i class="fas fa-store text-purple-300 text-xs"></i>
                      </div>
                      <p class="text-xs font-bold text-white mt-1 truncate" dir="ltr">
                        {{ formatMoney(posTotal) }}
                      </p>
                      <p class="text-[10px] text-gray-500 mt-0.5">
                        {{ formatNumber(posItemCount) }} آیتم
                      </p>
                      <p
                          v-if="posReturnsTotal > 0"
                          class="text-[10px] text-rose-300 mt-0.5 truncate"
                          dir="ltr"
                      >
                        مرجوعی: - {{ formatMoney(posReturnsTotal) }}
                      </p>

                      <p
                          v-if="posGrossTotal !== posTotal"
                          class="text-[10px] text-gray-500 mt-0.5 truncate"
                          dir="ltr"
                      >
                        ناخالص حضوری: {{ formatMoney(posGrossTotal) }}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div class="grid grid-cols-1 sm:grid-cols-3 gap-2 mt-3 min-w-0">
                <div class="rounded-2xl bg-cyan-500/10 border border-cyan-400/20 px-3 py-3 min-w-0">
                  <div class="flex items-center justify-between gap-2">
                    <p class="text-[10px] text-cyan-200 truncate">
                      پرداخت نقدی
                    </p>
                    <i class="fas fa-money-bill-wave text-cyan-300 text-xs"></i>
                  </div>
                  <p class="text-xs font-bold text-white mt-1 truncate" dir="ltr">
                    {{ formatMoney(cashTotal) }}
                  </p>
                </div>

                <div class="rounded-2xl bg-indigo-500/10 border border-indigo-400/20 px-3 py-3 min-w-0">
                  <div class="flex items-center justify-between gap-2">
                    <p class="text-[10px] text-indigo-200 truncate">
                      پرداخت چکی
                    </p>
                    <i class="fas fa-money-check-alt text-indigo-300 text-xs"></i>
                  </div>
                  <p class="text-xs font-bold text-white mt-1 truncate" dir="ltr">
                    {{ formatMoney(checkTotal) }}
                  </p>
                </div>

                <div class="rounded-2xl bg-orange-500/10 border border-orange-400/20 px-3 py-3 min-w-0">
                  <div class="flex items-center justify-between gap-2">
                    <p class="text-[10px] text-orange-200 truncate">
                      چک‌های سررسیدنشده
                    </p>
                    <i class="fas fa-clock text-orange-300 text-xs"></i>
                  </div>
                  <p class="text-xs font-bold text-white mt-1 truncate" dir="ltr">
                    {{ formatMoney(pendingTotal) }}
                  </p>
                </div>
              </div>
            </template>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'PartnerDashboardHero',

  props: {
    partnerId: {
      type: [String, Number],
      default: null
    },
  },

  data() {
    return {
      loading: false,
      error: null,
      selectedSource: 'both',
      activityOpen: false,

      sourceOptions: [
        {value: 'both', label: 'همه فروش‌ها'},
        {value: 'shop', label: 'فقط آنلاین'},
        {value: 'pos', label: 'فقط حضوری'}
      ],

      balanceData: null,
      mockLastPaymentAmount: 0
    }
  },

  computed: {
    returnsTotal() {
      return this.sales.returns_total || 0
    },

    netTotal() {
      if (this.sales.net_total !== undefined && this.sales.net_total !== null) {
        return this.sales.net_total
      }

      return Number(this.grossTotal || 0) - Number(this.returnsTotal || 0)
    },
    lastPayment() {
      return this.payments && this.payments.last_payment
          ? this.payments.last_payment
          : null
    },

    lastPaymentAmount() {
      return this.lastPayment ? this.lastPayment.amount_toman : 0
    },

    lastPaymentTitle() {
      if (!this.lastPayment) return 'هنوز پرداختی ثبت نشده'

      const type = this.lastPayment.payment_type_label || 'پرداخت'
      const date = this.lastPayment.date ? this.formatDateOnly(this.lastPayment.date) : ''

      return date ? `${type} / ${date}` : type
    },

    cashTotal() {
      return this.payments.cash_total || 0
    },

    checkTotal() {
      return this.payments.check_total || 0
    },

    pendingTotal() {
      return this.payments.pending_total || 0
    },

    paymentCount() {
      return this.payments.total_count || 0
    },
    userFirstName() {
      return this.user && this.user.first_name ? this.user.first_name : 'شریک عزیز'
    },

    userInitial() {
      return this.userFirstName ? this.userFirstName.charAt(0) : 'ش'
    },

    sales() {
      return this.balanceData && this.balanceData.sales
          ? this.balanceData.sales
          : {}
    },

    payments() {
      return this.balanceData && this.balanceData.payments
          ? this.balanceData.payments
          : {}
    },

    balance() {
      return this.balanceData && this.balanceData.balance
          ? this.balanceData.balance
          : {}
    },

    grossTotal() {
      return this.sales.gross_total || 0
    },

    shopTotal() {
      return this.sales.shop_total || 0
    },

    posTotal() {
      return this.sales.pos_total || 0
    },
    posGrossTotal() {
      return this.sales.pos && this.sales.pos.gross_total !== undefined
          ? this.sales.pos.gross_total
          : this.posTotal
    },

    posReturnsTotal() {
      return this.sales.pos && this.sales.pos.returns_total
          ? this.sales.pos.returns_total
          : 0
    },
    paidTotal() {
      return this.payments.paid_total || 0
    },

    balanceAmount() {
      return this.balance.amount || 0
    },

    shopItemCount() {
      return this.sales.shop && this.sales.shop.item_count
          ? this.sales.shop.item_count
          : 0
    },

    posItemCount() {
      return this.sales.pos && this.sales.pos.item_count
          ? this.sales.pos.item_count
          : 0
    },

    calculatedUntil() {
      return this.balanceData ? this.balanceData.calculated_until : null
    },

    lastSale() {
      return this.balanceData ? this.balanceData.last_sale : null
    },

    lastSaleAmount() {
      return this.lastSale ? this.lastSale.amount : 0
    },

    lastSaleTitle() {
      if (!this.lastSale) return 'هنوز فروشی ثبت نشده'

      const source = this.lastSale.source_label || ''
      const product = this.lastSale.product && this.lastSale.product.name
          ? this.lastSale.product.name
          : 'محصول'

      return `${source} / ${product}`
    }
  },

  watch: {
    partnerId() {
      this.fetchBalance()
    }
  },

  methods: {
    formatDateOnly(dateString) {
      if (!dateString) return '-'

      const date = new Date(dateString)
      if (Number.isNaN(date.getTime())) return '-'

      return new Intl.DateTimeFormat('fa-IR', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit'
      }).format(date)
    },
    formatNumber(value) {
      if (value === null || value === undefined || value === '') return '۰'

      const number = Number(value)
      if (Number.isNaN(number)) return '۰'

      return new Intl.NumberFormat('fa-IR').format(number)
    },

    formatMoney(value) {
      return `${this.formatNumber(Math.round(Number(value || 0)))} تومان`
    },

    formatDateShort(dateString) {
      if (!dateString) return '-'

      const date = new Date(dateString)
      if (Number.isNaN(date.getTime())) return '-'

      return new Intl.DateTimeFormat('fa-IR', {
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit'
      }).format(date)
    },

    buildEndpoint(path) {
      if (this.endpoint && typeof this.endpoint === 'function') {
        return this.endpoint(path)
      }

      return path
    },

    fetchBalance() {
      this.loading = true
      this.error = null

      let url = this.buildEndpoint('deliver/chart/sales-balance')

      const params = []

      if (this.partnerId) {
        params.push(`partner_id=${encodeURIComponent(this.partnerId)}`)
      }
      if (this.selectedSource) {
        params.push(`source=${encodeURIComponent(this.selectedSource)}`)
      }
      if (params.length) {
        url += `?${params.join('&')}`
      }

      this.request({
        url,
        method: 'get',
        success: (response) => {
          this.balanceData = response
          this.loading = false
        },
        error: (err) => {
          console.error('PartnerDashboardHero API error:', err)
          this.error = 'خطا در دریافت موجودی فروش'
          this.loading = false
        }
      })
    },
    onFilterChange() {
      this.fetchBalance()
    }
  },

  mounted() {
    this.fetchBalance()
  }
}
</script>

<style scoped>
.hero-wallet-root,
.hero-wallet-root * {
  box-sizing: border-box;
}

.hero-wallet-root {
  position: relative;
  isolation: isolate;
}

.absolute-layer {
  position: absolute;
  inset: 0;
  overflow: hidden;
}

.hero-grid {
  background-image: linear-gradient(to right, rgba(255, 255, 255, 0.12) 1px, transparent 1px),
  linear-gradient(to bottom, rgba(255, 255, 255, 0.12) 1px, transparent 1px);
  background-size: 28px 28px;
}

.pulse-orb {
  animation: heroPulse 3s ease-in-out infinite;
}

.pulse-orb-delayed {
  animation: heroPulse 4s ease-in-out infinite;
  animation-delay: 1s;
}

.spin-slow {
  animation: spinSlow 1s linear infinite;
}

@keyframes heroPulse {
  0%, 100% {
    opacity: 0.45;
    transform: scale(1);
  }

  50% {
    opacity: 0.9;
    transform: scale(1.08);
  }
}

@keyframes spinSlow {
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(360deg);
  }
}

.break-safe {
  overflow-wrap: anywhere;
  word-break: break-word;
}

.min-w-0 {
  min-width: 0 !important;
}

.rotate-180 {
  transform: rotate(180deg);
}

.collapse-enter-active,
.collapse-leave-active {
  transition: all 0.2s ease;
}

.collapse-enter,
.collapse-leave-to {
  opacity: 0;
  transform: translateY(-4px);
}

select,
button {
  max-width: 100%;
}
</style>